import BaseModelAPI from '../BaseModelAPI';

export default class DownloadProcess extends BaseModelAPI {
	static entity = 'downloadprocess';
	static entityName = 'downloadprocess';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.jobId = '';
			this.functionId = '';
			this.fileName = '';
			this.startTime = '';
			this.endTime = '';
			this.status = '';
			this.errorMessage = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}